import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { ModalProps } from '@shared/ui/organisms';
import { Button } from '@shared/ui/molecules';
import { Text } from '@shared/ui/atoms';
import { CrossIcon } from '@shared/assets/icons';
import suggestResultModalTopImage from '../assets/suggest-result-modal-top-image.webp';
type SuggestionSentContentProps = Pick<ModalProps, 'onClose'>;
const SuggestionSentContent: FC<SuggestionSentContentProps> = ({
  onClose
}) => <>
    <ImageWrapper>
      <Image src={suggestResultModalTopImage} alt="Предложка" width={600} height={200} />
    </ImageWrapper>
    <ContentWrapper>
      <IconButtonWrapper type="button" onClick={onClose}>
        <CrossIcon />
      </IconButtonWrapper>
      <TextWrapper>
        <Text size={{
        desktop: 'h4',
        mobile: 'h6'
      }} weight="bold">
          Спасибо!
        </Text>
        <Text size={{
        desktop: 'h6',
        mobile: 'pM'
      }} family="MTSCompact" color="secondary">
          Ваши идеи уже у нас, работаем над тем, чтобы они не пылились в инвентаре
        </Text>
      </TextWrapper>
      <Button type="button" size={{
      desktop: '72',
      mobile: '52'
    }} onClick={onClose}>
        Отлично
      </Button>
    </ContentWrapper>
  </>;
export default SuggestionSentContent;
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "islpow7",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1k0e8uy",
  propsAsIs: false,
  vars: {
    "c1k0e8uy-0": [_exp()]
  }
}));
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "i1o2e82d",
  propsAsIs: false,
  vars: {
    "i1o2e82d-0": [_exp2()]
  }
}));
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "tvjqkku",
  propsAsIs: false
});

require("./SuggestionSentContent.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SuggestionSentContent.tsx");